import React from 'react';
import { createRoot } from 'react-dom/client';
import {
  AllEnterpriseModule,
  LicenseManager,
  ModuleRegistry,
} from 'ag-grid-enterprise';
import { provideGlobalGridOptions } from 'ag-grid-community';
import { AgChartsCommunityModule } from 'ag-charts-community';

import './index.css';
import App from './components/App';
// import registerServiceWorker from './registerServiceWorker';

import reportWebVitals from './reportWebVitals';

ModuleRegistry.registerModules([
  AllEnterpriseModule.with(AgChartsCommunityModule),
]);
LicenseManager.setLicenseKey(
  'Using_this_{AG_Grid}_Enterprise_key_{AG-082829}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{NEPC,_LLC}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{ClientHUB}_only_for_{2}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{ClientHUB}_need_to_be_licensed___{ClientHUB}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{19_July_2026}____[v3]_[01]_MTc4NDQxNTYwMDAwMA==befd32a8e7f4c915be4f0b39d0598d18'
);
provideGlobalGridOptions({ theme: 'legacy' });

const container = document.getElementById('root');
const root = createRoot(container);

root.render(<App />);

// registerServiceWorker();

reportWebVitals();
